import { AppRoutes as Route } from "./AppRoutes";
export default Route;
